import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import MotivoDepuracion from './MotivoDepuracion.js';
import ACCESS from '../../../ACCESS.js';

class MotivosDepuracion extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'motivo-depuracion/filter', deleteUrl: 'motivo-depuracion/delete', deleteField: 'motivo_depuracion_nombre', modUrl: '/Catalogo/MotivoDepuracion' },
      TableOp.Table('Motivos de Depuracion', [
        { label: 'Clave', id: 'motivo_depuracion_motivo' },
        { label: 'Nombre', id: 'motivo_depuracion_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_MOTIVO_DEPURACION.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_MOTIVO_DEPURACION.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <MotivoDepuracion  onSave={() => {this.table()}}></MotivoDepuracion>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(MotivosDepuracion)